import { history } from 'store/store'
import { getQueryVariable } from 'utils/getQueryVariable'

const isCurrentPathLoginOrLogout = window.location.pathname === '/logout' || window.location.pathname === '/login'

export const getCurrentUrl = () => (isCurrentPathLoginOrLogout ? '/' : encodeURI(window.location.pathname + window.location.search))

export const redirectToLogin = () => {
  history.push(`/login?returnUrl=${getCurrentUrl()}`)
}

export const redirectToLogout = () => {
  history.push(`/logout?returnUrl=${getCurrentUrl()}`)
}

export const redirectToReturnUrl = () => {
  const returnUrl = getQueryVariable('returnUrl')
  history.push(returnUrl || '/')
}
